import "./cardDecommisionView.scss";

import { DOMHelper, View } from "~ui-lib";

export class CardDecommissionView extends View {
  constructor(item: string) {
    super(DOMHelper.createDivWithParent(null, "CardDecommisionView", "CardDecomission "));

    const box = DOMHelper.createDivWithParent(this.rootElement, null, "btnBox");

    const text = DOMHelper.createSpanWithParent(box, null, "btnText", item.toString());

    text.style.paddingLeft = "66px";
    DOMHelper.createDivWithParent(box, null, "iconGoTo", " ");
    text.style.paddingRight = "66px";
  }
}
